import { render, staticRenderFns } from "./swiperImg.vue?vue&type=template&id=00b3ee31"
import script from "./swiperImg.vue?vue&type=script&lang=js"
export * from "./swiperImg.vue?vue&type=script&lang=js"
import style0 from "./swiperImg.vue?vue&type=style&index=0&id=00b3ee31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports